import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { AiFillEye, AiFillEyeInvisible } from "react-icons/ai";
import { useTheme } from "../BrandColors/Context/ThemeContext";

const ProfileCard = () => {
  const navigate = useNavigate();
  const theme = useTheme() || "#3b82f6";
  const [isModalOpen, setModalOpen] = useState(false);

  const user = JSON.parse(localStorage.getItem("user"));

  const [profileData, setProfileData] = useState({
    firstName: "Sanjay",
    email: user.email,
    profileImage: "https://imgs.search.brave.com/gxCbEM2l_nRW9ROLoaUzhpkPNmSOgpcdNYZjIk8svTY/rs:fit:860:0:0:0/g:ce/aHR0cHM6Ly9pbWcu/ZnJlZXBpay5jb20v/ZnJlZS1waG90by91/c2VyLXByb2ZpbGUt/aWNvbi1mcm9udC1z/aWRlXzE4NzI5OS0z/OTU5Ni5qcGc_c2Vt/dD1haXNfaHlicmlk", // URL or local image path
    password: ".....",
    role: user.role
  });

  const [showPassword, setShowPassword] = useState(false);

  const [tempProfileData, setTempProfileData] = useState({ ...profileData });
  const [profileImageFile, setProfileImageFile] = useState(null);

  const handleHome = () => {
    navigate("/");
  };

  const handleEdit = () => {
    setTempProfileData({ ...profileData }); // Initialize temp data with current profile data
    setModalOpen(true);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setTempProfileData((prev) => ({ ...prev, [name]: value }));
  };

  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      setProfileImageFile(file);
      const fileURL = URL.createObjectURL(file); // Generate local URL for preview
      setTempProfileData((prev) => ({ ...prev, profileImage: fileURL }));
    }
  };


  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };


  const handleSaveChanges = () => {
    if (profileImageFile) {
      // Optional: Handle file upload to server here
      console.log("Uploading image file:", profileImageFile);
    }
    setProfileData(tempProfileData); // Save the temporary data to main state
    setModalOpen(false);
  };

  return (
    <div className="glass-panel max-w-2xl mx-auto w-full flex flex-col p-8 animate-fade-in-up mt-10 rounded-2xl shadow-2xl relative overflow-hidden">
      
      {/* Decorative background element */}
      <div 
        className="absolute top-0 left-0 w-full h-32 opacity-20 -z-10"
        style={{ background: `linear-gradient(to bottom, ${theme}, transparent)` }}
      />

      <div className="flex flex-col items-center mb-8 relative z-10">
        <div className="relative group mb-4">
          <div className="w-28 h-28 rounded-full overflow-hidden border-4 border-white shadow-xl" style={{ borderColor: theme }}>
            {profileData.profileImage ? (
              <img
                src={profileData.profileImage}
                alt="Avatar"
                className="w-full h-full object-cover"
              />
            ) : (
              <div className="w-full h-full bg-slate-700 flex items-center justify-center text-slate-600 text-3xl font-bold">
                {profileData.firstName?.charAt(0).toUpperCase()}
              </div>
            )}
          </div>
          <div className="absolute bottom-1 right-1 w-5 h-5 bg-green-500 border-2 border-dark-900 rounded-full"></div>
        </div>
        
        <div className="text-center">
          <h2 className="text-3xl font-bold text-white tracking-tight">{profileData.firstName}</h2>
          <span className="inline-block px-3 py-1 mt-2 rounded-full text-xs font-semibold tracking-wider uppercase bg-white border border-blue-200 text-slate-700" style={{ color: theme }}>
            {profileData.role}
          </span>
        </div>
      </div>

      <div className="bg-white/50 rounded-xl p-6 border border-blue-200/50 mb-8 w-full backdrop-blur-sm">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div className="flex flex-col gap-1.5">
            <span className="text-xs font-medium text-slate-600 uppercase tracking-wider">First Name</span>
            <p className="text-lg font-medium text-white">{profileData.firstName}</p>
          </div>
          <div className="flex flex-col gap-1.5">
            <span className="text-xs font-medium text-slate-600 uppercase tracking-wider">Email</span>
            <p className="text-lg font-medium text-white">{profileData.email}</p>
          </div>
          <div className="flex flex-col gap-1.5 md:col-span-2 pt-4 border-t border-blue-200/50">
            <span className="text-xs font-medium text-slate-600 uppercase tracking-wider">Password</span>
            <p className="text-lg font-medium text-white tracking-widest">{profileData.password}</p>
          </div>
        </div>
      </div>

      <div className="flex justify-center gap-4 w-full">
        <button 
          className="px-6 py-3 rounded-lg font-medium text-white shadow-lg transition-transform hover:-translate-y-0.5 active:translate-y-0 w-full sm:w-auto"
          style={{ backgroundColor: theme }}
          onClick={handleEdit}
        >
          Edit Profile
        </button>
        <button 
          onClick={handleHome} 
          className="px-6 py-3 rounded-lg font-medium text-slate-700 bg-white hover:bg-blue-100 transition-colors border border-blue-200 shadow-md w-full sm:w-auto"
        >
          Back to Home
        </button>
      </div>

      {isModalOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm">
          <div className="glass-panel w-full max-w-md p-6 rounded-2xl shadow-2xl animate-scale-in">
            <div className="mb-6 pb-4 border-b border-blue-200/50">
              <h2 className="text-2xl font-bold text-white">Edit Profile</h2>
            </div>
            
            <div className="flex flex-col gap-5">
              <div className="flex flex-col gap-1.5">
                <label className="text-sm font-medium text-slate-700">First Name</label>
                <input
                  className="input-field"
                  type="text"
                  name="firstName"
                  value={tempProfileData.firstName}
                  onChange={handleInputChange}
                />
              </div>

              <div className="flex flex-col gap-1.5">
                <label className="text-sm font-medium text-slate-700">Email</label>
                <input
                  className="input-field"
                  type="email"
                  name="email"
                  value={tempProfileData.email}
                  onChange={handleInputChange}
                />
              </div>

              <div className="flex flex-col gap-1.5">
                <label className="text-sm font-medium text-slate-700">Profile Image URL</label>
                <input
                  className="input-field"
                  type="text"
                  name="profileImage"
                  placeholder="Enter image URL"
                  value={tempProfileData.profileImage}
                  onChange={handleInputChange}
                />
              </div>
              
              <div className="flex flex-col gap-1.5">
                <label className="text-sm font-medium text-slate-700">Or Upload Image</label>
                <input
                  className="w-full text-sm text-slate-600 file:mr-4 file:py-2 file:px-4 file:rounded-lg file:border-0 file:text-sm file:font-semibold file:bg-white file:text-slate-700 hover:file:bg-blue-100 cursor-pointer"
                  type="file"
                  accept="image/*"
                  onChange={handleImageUpload}
                />
              </div>

              <div className="flex flex-col gap-1.5">
                <label className="text-sm font-medium text-slate-700">Password</label>
                <div className="relative">
                  <input
                    type={showPassword ? "text" : "password"}
                    name="password"
                    placeholder="Password"
                    value={tempProfileData.password}
                    onChange={handleInputChange}
                    className="input-field pr-10"
                  />
                  <button
                    type="button"
                    className="absolute inset-y-0 right-0 flex items-center pr-3 text-slate-600 hover:text-slate-700"
                    onClick={togglePasswordVisibility}
                  >
                    {showPassword ? <AiFillEyeInvisible size={20} /> : <AiFillEye size={20} />}
                  </button>
                </div>
              </div>

              <div className="flex justify-end gap-3 mt-4 pt-4 border-t border-blue-200/50">
                <button 
                  className="px-5 py-2.5 rounded-lg font-medium text-slate-700 bg-white hover:bg-blue-100 transition-colors border border-blue-200" 
                  onClick={handleCloseModal}
                >
                  Cancel
                </button>
                <button 
                  className="px-5 py-2.5 rounded-lg font-medium text-white shadow-lg transition-transform hover:-translate-y-0.5 active:translate-y-0"
                  style={{ backgroundColor: theme }}
                  onClick={handleSaveChanges}
                >
                  Save Changes
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ProfileCard;
